<template>
  <v-card class="crud-dialog">
    <v-card-title class="headline">
      <v-icon>security</v-icon> N° de Solicitud: {{ tramite.id }}
      <div class="tramite-estado">
        <v-chip label :color="estados[tramite.estado]" text-color="white">
          <small>{{ tramite.estado ? tramite.estado.replace(/_/gi, ' ') : '' }}</small>
        </v-chip>
      </div>
      <v-btn icon @click.native="cerrar_ventana">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs4 v-show="detalles">
          <detalle-doc :solicitud="tramite" :pagos="pagos"></detalle-doc>
        </v-flex>
        <v-flex xs8 :class="{ xs12: !detalles }">
          <v-card-actions class="margin-0 p-l-0 p-r-0 p-t-0">
            <v-tooltip top class="margin-0">
              <v-btn
                type="button"
                slot="activator"
                class="margin-0"
                @click="detalles = !detalles">
                <v-icon>{{ detalles ? 'chevron_left' : 'chevron_right' }}</v-icon>
                {{ detalles ? 'Ocultar' : 'Mostrar' }}
              </v-btn>
              <span>{{ detalles ? 'Ocultar' : 'Mostrar' }} detalles</span>
            </v-tooltip>
            <template v-for="(item, index) in pagos">
              <v-spacer></v-spacer>
              <v-tooltip top class="margin-0" v-if="$store.state.user.id_rol === 4 && tramite.estado === 'APOSTILLADO'">
              <v-btn
              color="info"
              @click="imprimir()"
              slot="activator">
              <v-icon>print</v-icon> IMPRIMIR EN HOJA MEMBRETADA
              </v-btn>
              <span> Versión para imprimir en hoja membretada</span>
              </v-tooltip>
              <v-tooltip top class="margin-0">
                <!-- <v-btn
                  color="info"
                  v-if="$store.state.permissions['tramitesDoc:update'] && $store.state.user.id_rol === 6 && (item.estado == 'HABILITADO' || tramite.estado == 'REVISADO_ENTIDAD')"
                  slot="activator"
                  :disabled = "item.estado == 'PAGADO'"
                  @click.native="generarCpt(tramite, 'ENTIDAD')">
                  <v-icon left>monetization_on</v-icon> REGENERAR CPT
                </v-btn> -->
                <v-btn
                  color="info"
                  v-if="$store.state.permissions['tramitesDoc:update'] && $store.state.user.id_rol === 3 && (item.estado == 'HABILITADO' || tramite.estado == 'REVISADO_ENTIDAD')"
                  slot="activator"
                  :disabled = "item.estado == 'PAGADO'"
                  @click.native="generarCpt(tramite, 'CANCILLERIA')">
                    <v-icon>monetization_on</v-icon> REGENERAR CPT
                </v-btn>
                <span v-if="item.estado == 'PAGADO'">No se puede regenerar Código de Pago(CPT) de un trámite pagado</span>
                <span v-else> Regenerar Código de Pago(CPT)</span>
              </v-tooltip>
            </template>
          </v-card-actions>
          <div class="pdf-container">
           <v-layout row wrap v-if="($store.state.user.id_rol === 4 || $store.state.user.id_rol === 3) && solicitud.firmante" class="firma-detalle">
              <v-flex xs6>
                <h5>Datos firmante designado</h5>
                <strong>Nombre:</strong> {{ solicitud.firmante.firmante_nombre_completo }} <br />
                <strong>Cargo:</strong> {{ solicitud.firmante.firmante_cargo ||'[no registrado]' }} <br />
                <strong>Entidad:</strong> {{ solicitud.firmante.entidad_nombre }}
              </v-flex>
              <v-flex xs6 v-if="solicitud.firmante.certicado_token">
                <h5>Datos firma en documento</h5>
                <strong>Nombre:</strong> {{ solicitud.firmante.certicado_token.nombreComunSubject }} <br />
                <strong>Certificado por:</strong> {{ solicitud.firmante.certicado_token.nombreComunIssuer }} <br />
                <strong>Fecha inicio validez:</strong> {{ solicitud.firmante.certicado_token.inicioValidez}} <br />
                <strong>Fecha fin validez:</strong> {{ solicitud.firmante.certicado_token.finValidez }} <br />
                <!--<strong>Cargo:</strong> {{ solicitud.firmante.certicado_token.unidadOrganizacionalSubject }} <br />-->
                <!--<strong>Entidad:</strong> {{ solicitud.firmante.certicado_token.organizacionSubject }}-->
              </v-flex>
            </v-layout>
            <pdf-view :data="pdf" :url="urlPdf" v-if="pdf && tramite.id_archivo > 1"></pdf-view>
            <v-alert color="warning" icon="warning" value="true" v-if="tramite.id_archivo == 1">
              No se adjuntó ningún documento PDF
            </v-alert>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import tramiteDoc from './mixins/tramite_doc';
import DetalleDoc from './DetalleDoc';
import PdfView from '@/common/util/pdf/PdfView';
import axios from 'axios';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

export default {
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true
    };
  },
  mixins: [ tramiteDoc ],
  created () {
    // Cargando tramite
    this.getTramite(this.solicitud.id);
  },
  components: {
    DetalleDoc,
    PdfView
  },
  methods: {
    imprimir () {
      // alert(JSON.stringify(this.tramite));
      const url = `${this.$apiUrl}eapostilla/apostilla_para_imprimir/${this.tramite.id_archivo}/${this.tramite.id}`;
      axios({
        url: url,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + this.$storage.get('token')
        },
        json: true,
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const d = new Date();
        link.setAttribute('download', this.$store.state.user.usuario + d.getTime() + '.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    cerrar_ventana () {
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function (val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    }
  }
};
</script>

<style src="./tramite.scss" lang="scss"></style>



// WEBPACK FOOTER //
// Detalle.vue?5aefe7f4